import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarIcon from "../../../assets/blade-runner/navbar-icon-blade-runner.webp";

const session11To20Links = [
  {
    href: "/blade-runner-session-12",
    label: "12: Prophecy (Case: Fiery Angels) [05-15-2026]",
  },
  {
    href: "/blade-runner-session-11",
    label: "11: Sea Wall Showdown (Case: Fiery Angels) [04-11-2026]",
  },
];

const session00To10Links = [
  {
    href: "/blade-runner-session-10",
    label: "10: McCoy (Case: Fiery Angels) [03-27-2026]",
  },
  {
    href: "/blade-runner-session-09",
    label: "09: Neon Mirror (Case: Fiery Angels) [03-15-2026]",
  },
  {
    href: "/blade-runner-session-08",
    label: "08: Bright Eyes (Case: Fiery Angels) [03-01-2026]",
  },
  {
    href: "/blade-runner-session-07",
    label: "07: The Leash (Case: Fiery Angels) [01-23-2026]",
  },
  {
    href: "/blade-runner-session-06",
    label: "06: Sign of the Times (Case: Electric Dreams) [01-10-2026]",
  },
  {
    href: "/blade-runner-session-05",
    label: "05: Mindkill (Case: Electric Dreams) [12-19-2025]",
  },
  {
    href: "/blade-runner-session-04",
    label: "04: Safehouse (Case: Electric Dreams) [10-17-2025]",
  },
  {
    href: "/blade-runner-session-03",
    label: "03: Memory Lab (Case: Electric Dreams) [09-19-2025]",
  },
  {
    href: "/blade-runner-session-02",
    label: "02: The Tyger (Case: Electric Dreams) [08-15-2025]",
  },
  {
    href: "/blade-runner-session-01",
    label: "01: Waking Up (Case: Electric Dreams) [08-09-2025]",
  },
  { href: "/blade-runner-session-00", label: "00: Training Day [03-29-2025]" },
];

const toolsLinks = [
  { href: "/blade-runner-overview", label: "Blade Runner Overview" },
  { href: "/blade-runner-classes", label: "Blade Runner Classes" },
  { href: "/blade-runner-rules", label: "Blade Runner Rules" },
];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const BRNavBar = () => {
  return (
    <NavDropdown title="Blade Runner" id="blade-runner-nav-dropdown">
      <NavDropdown.Header>
        <div style={{ textAlign: "center" }}>The Immortality Game</div>
      </NavDropdown.Header>
      <NavDropdown.Header>
        <img src={NavBarIcon} alt="Blade Runner" style={{ maxHeight: 85 }} />
      </NavDropdown.Header>

      <NavDropdown title="Sessions 11-20" id="blade-runner-sessions-11-20">
        {renderLinks(session11To20Links)}
      </NavDropdown>

      <NavDropdown title="Sessions 00-10" id="blade-runner-sessions-00-10">
        {renderLinks(session00To10Links)}
      </NavDropdown>

      <NavDropdown title="Tools and Info" id="blade-runner-tools-and-info">
        {renderLinks(toolsLinks)}
      </NavDropdown>
    </NavDropdown>
  );
};

export default BRNavBar;
